module.exports = __webpack_public_path__ + "static/media/streamline_process.5138980f.png";